<template>
    <div class="mb-0 mt-3 px-0 mx-0 w-100" style="max-width: none">
        <h5 v-if="(vtc.waiting_diffs_count === 0 && !vtc.providers) ||
        (vtc.waiting_diffs_count === 0 && vtc.providers && vtc.providers.length === 0)"
            class="text-center">
            Pour commencer à recevoir des mises à jour : ajouter des prestataires à votre veille.
        </h5>
        <h5 v-else-if="vtc.waiting_diffs_count === 0" class="text-center">
            Vous n'avez aucune Mise à jour en attente de traitement
        </h5>
        <div class="row justify-content-evenly" v-else>
            <!--            liste des diffs en attente de traitement    -->
            <div class="col-6 w-100 border-right vtcDiffListBlock pt-0">
                <div class="sticky-top bg-white">
                    <div class="d-flex justify-content-between pt-1" v-if="vtc.waiting_diffs_count > 0">
                        <div class="d-flex">
                            <v-checkbox hide-details @change="checkAllDiffs($event)" class="ml-4 mt-auto mb-auto"
                                        v-model="allDiffsIsChecked">
                            </v-checkbox>

                            <v-text-field @input="setNameToFilter" :value="waitingDiffSearchName"
                                          append-icon="mdi-magnify" label="Rechercher par nom"
                                          style="padding-top: 0 !important;"
                                          clearable class="mr-4 mt-1" outlined hide-details>
                            </v-text-field>
                        </div>


                        <div class="d-flex mt-1">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn outlined class="custom-button-primary mr-2" style="height: 40px"
                                           @click="prepareMultiUpdateRead(false)" v-on="on">
                                        <v-icon>mark_as_unread</v-icon>
                                    </v-btn>
                                </template>
                                <span>Marquer comme non lu</span>
                            </v-tooltip>

                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn outlined class="custom-button-primary mr-2" style="height: 40px"
                                           @click="prepareMultiUpdateRead(true)" v-on="on">
                                        <v-icon>mark_email_read</v-icon>
                                    </v-btn>
                                </template>
                                <span>Marquer comme lu</span>
                            </v-tooltip>

                            <v-tooltip top v-if="waitingVtcDiffSortOrder === 'desc'">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn outlined class="custom-button-primary" style="height: 40px"
                                           @click="setWaitingVtcDiffSortOrder('asc')" v-on="on">
                                        <v-icon>arrow_downward</v-icon>
                                    </v-btn>
                                </template>
                                <span>Trier par date croissante</span>
                            </v-tooltip>

                            <v-tooltip top v-if="waitingVtcDiffSortOrder === 'asc'">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn outlined class="custom-button-primary"
                                           @click="setWaitingVtcDiffSortOrder('desc')" v-on="on">
                                        <v-icon>arrow_upward</v-icon>
                                    </v-btn>
                                </template>
                                <span>Trier par date décroissante</span>
                            </v-tooltip>
                        </div>
                    </div>
                </div>

                <div v-if="vtc.waiting_diffs_count > 0 && vtc.diffs.length === 0" class="text-center mt-4">
                    <h5>
                        Aucune mise à jour trouvé
                    </h5>
                </div>
                <div v-for="diff in vtc.diffs" v-else
                     class="vtcDiffCard border rounded w-100 mb-2 pr-3 d-flex justify-content-between"
                     @click="selectDiff(diff)" :class="{'bg-light':selectedDiff && selectedDiff.id === diff.id}">
                    <div class="d-flex col-8">
                        <v-checkbox hide-details @change="checkDiff($event, diff)" class="mt-auto mb-auto"
                                    style="padding-top: 0 !important"
                                    v-model="diff.selected">
                        </v-checkbox>
                        <div class="d-flex flex-column mt-auto mb-auto ml-3">
                            <h5 class="text-primary">
                                {{ diff.provider_name }}
                            </h5>
                            <small class="font-italic">
                                {{ diff.provider_category }}
                            </small>
                        </div>
                    </div>

                    <div class="mt-auto mb-auto">
                        <span :class="{'mr-7': diff.read}">
                        {{ formatDate(diff.date) }}
                    </span>
                        <v-icon color="primary" v-if="!diff.read">circle</v-icon>
                    </div>
                </div>
            </div>

            <!--    détail de la diff   -->
            <div class="col-6 w-100">
                <div>
                    <p v-if="vtc.diffs && vtc.diffs.length >0 && selectedDiff === null" class="text-center">
                        Vous n'avez sélectionné aucune Mise à jour
                    </p>
                    <div v-else-if="vtc.diffs && vtc.diffs.length >0">
                        <div class="d-flex justify-content-between sticky-top bg-white border-bottom mr-2">
                            <router-link :to="'/summary/' + getB64(selectedDiff.provider_id)">
                                <h4>{{ selectedDiff.provider_name }}</h4>
                            </router-link>
                            <div class="d-flex">
                                <v-tooltip bottom v-if="selectedDiff.apidae_url">
                                    <template v-slot:activator="{ on }">
                                        <a :href="selectedDiff.apidae_url" target="_blank">
                                            <v-icon right color="blue" v-on="on">open_in_new</v-icon>
                                        </a>
                                    </template>
                                    <span>Voir sur Apidae</span>
                                </v-tooltip>
                            </div>
                        </div>

                        <div class="vtcDiffBlock px-2">
                            <sit-answer-diffs-step :languages="languages" :vt="true">
                            </sit-answer-diffs-step>
                        </div>

                        <div class="d-flex justify-content-between bg-white mt-2 pr-2">
                            <v-btn outlined class="custom-button-primary mr-2" @click="refuseVtcDiff">
                                <v-icon>clear</v-icon>
                                Refuser
                            </v-btn>
                            <v-btn outlined class="default-button" @click="sentToApidae"
                                   v-if="selectedDiff.diffs.length > 0">
                                <v-icon left>arrow_forward</v-icon>
                                Envoyer sur Apidae
                            </v-btn>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex"
import SitAnswerDiffsStep from "../webform/sit-answer-steppers/SitAnswerDiffsStep.vue"
import _ from "lodash"

export default {
    name: "VtcWaitingDiffs",
    components: { SitAnswerDiffsStep },
    data() {
        return {
            allDiffsIsChecked: false,
            checkedDiffsCount: 0,
            languages: [],
            selectedDiff: null,
        }
    },
    methods: {
        ...mapMutations("sitAnswer", ["setDiffs"]),
        ...mapMutations("vtc", ["setWaitingDiffSearchName", "setWaitingVtcDiffSortOrder"]),
        checkDiff(event, diff) {
            diff.selected = event

            if (event) {
                this.checkedDiffsCount++
            } else {
                this.checkedDiffsCount--
            }

            this.$forceUpdate()
        },
        checkAllDiffs(event) {
            this.vtc.diffs.forEach(diff => {
                diff.selected = event

                if (event) {
                    this.checkedDiffsCount++
                } else {
                    this.checkedDiffsCount--
                }
            })

            this.$forceUpdate()
        },
        prepareMultiUpdateRead(read) {
            let selectedDiffs = []

            this.vtc.diffs.forEach(diff => {
                if (diff.selected) {
                    selectedDiffs.push(diff.id)
                }
            })

            if (selectedDiffs.length === 0 && this.selectedDiff !== null) {
                selectedDiffs.push(this.selectedDiff.id)
            }

            this.updateRead(selectedDiffs, read)
        },
        updateRead(selectedDiffs, read) {
            this.vtc.diffs.forEach(diff => {
                if (selectedDiffs.includes(diff.id)) {
                    diff.read = read
                }
            })

            let payload = {
                vtcDiffIds: selectedDiffs,
                read: read,
            }

            this.$http.put("/veille-tourisme/vtc/vtc-diff/update-read", payload).then((res) => {
                this.allDiffsIsChecked = false
                this.checkedDiffsCount = 0
            })
        },
        getLanguages() {
            this.$http.get("resource/languages").then(res => {
                this.languages = res.body.data.languages
            })
        },
        selectDiff(diff) {
            this.selectedDiff = diff

            //si pas lu marquer comme lu
            if (!diff.read) {
                let selectedDiffs = []
                selectedDiffs.push(diff.id)

                this.updateRead(selectedDiffs, true)
            }
            //set diff pour le component
            this.setDiffs(diff.diffs)
        },
        sentToApidae() {
            this.$global.loading = true
            let payload = {
                vtcDiffId: this.selectedDiff.id,
            }

            this.$http.post("/veille-tourisme/vtc/vtc-diff/write-apidae", payload).then((res) => {
                this.$global.loading = false
                this.allDiffsIsChecked = false
                this.checkedDiffsCount = 0

                if (res.body.success) {
                    this.selectedDiff = null
                }

                this.$global.$emit("reload-vtc", "1")
                this.$store.dispatch("account/getVTNotificationsCount")
            })
        },
        getB64(id) {
            return btoa(id)
        },
        refuseVtcDiff() {
            this.$http.post("/veille-tourisme/vtc/vtc-diff/refuse/" + this.selectedDiff.id).then((res) => {
                this.$global.loading = false
                this.allDiffsIsChecked = false
                this.checkedDiffsCount = 0
                this.selectedDiff = null
                this.$global.$emit("reload-vtc", "1")
                this.$store.dispatch("account/getVTNotificationsCount")
            })
        },
        setNameToFilter: _.debounce(function(value) {
            this.setWaitingDiffSearchName(value)
        }, 300),
    },
    computed: {
        ...mapState("vtc", [
            "vtc",
            "currentStep",
            "waitingDiffSearchName",
            "waitingVtcDiffSortOrder",
        ]),
    },
    watch: {
        checkedDiffsCount() {
            if (this.vtc.diffs.length > 0) {
                this.allDiffsIsChecked = this.vtc.diffs.length === this.checkedDiffsCount
            }
        },
        currentStep() {
            if (this.currentStep == 1 && this.selectedDiff) {
                this.setDiffs(this.selectedDiff.diffs)
            }
        },
        waitingDiffSearchName() {
            this.selectedDiff = null
        },
    },
    created() {
        this.getLanguages()
    },
}
</script>